let promise;

export default function ($http, userRolesObject) {
    return function () {
        if (!promise) {
            promise = $http.get('api/users/userdetails');
        }

        return promise
            .then(result => {
                const userDetails = result.data;

                let user = null;

                if (userDetails) {
                    user = {
                        name: userDetails.name,
                        roles: userDetails.roles,
                        isAdmin: userDetails.roles.includes(userRolesObject.admin),
                        isOperator: userDetails.roles.includes(userRolesObject.operator),
                        isTeamLead: userDetails.roles.includes(userRolesObject.teamLead),
                        isAccountAdmin: userDetails.roles.includes(userRolesObject.accountAdmin),
                        isRrd: userDetails.roles.includes(userRolesObject.rrd)
                    };
                }

                return user;
            });
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/services/currentUser.js